import { Box } from '@mui/material';
import React from 'react';
import Slider from './Slider/Slider';

const carousalBox = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  height: '100%',
  overflow: 'hidden',
};

const crousel__wrapper = {
  maxWidth: '620px',
  width: '100%',
  position: 'relative',
  zIndex: 999,
};

const background__design1 = {
  height: '485px',
  width: '485px',
  position: 'absolute',
  borderRadius: '50%',
  background: '#036FCB',
  top: '-94px',
  right: '-175px',
};

const background__design2 = {
  height: '484px',
  width: '484px',
  background: '#00A0DF',
  position: 'absolute',
  borderRadius: '50%',
  bottom: '-273px',
  left: '-246px',
};

const background__design3 = {
  height: '213px',
  width: '213px',
  background: '#3C9DEB',
  position: 'absolute',
  borderRadius: '50%',
  bottom: '-73px',
  right: '-124px',
};

const CarouselWrapper = ({ carouselConfig }) => {
  const {
    topRightColor,
    bottomLeftColor,
    bottomRightColor,
    logo,
    carousel_content,
  } = carouselConfig;
  background__design1['background'] = topRightColor;
  background__design2['background'] = bottomLeftColor;
  background__design3['background'] = bottomRightColor;
  const carouselContent = carousel_content.map((item, index) => ({
    ...item,
    id: index,
  }));
  return (
    <Box sx={carousalBox}>
      <Box
        component="img"
        src={logo}
        alt="logo"
        sx={{
          position: 'absolute',
          top: 0,
          left: '12px',
          zIndex: 1,
          height: 120,
          width: 250,
        }}
      />
      <Box sx={crousel__wrapper}>
        <Slider imageSlider={carouselContent} />
      </Box>
      <Box sx={background__design1} />
      <Box sx={background__design2} />
      <Box sx={background__design3} />
    </Box>
  );
};

export default CarouselWrapper;
